import React from 'react';
import './styles/SmileLoader.css';

/** Крутящийся кружок-смайлик: глаза моргают / подмигивают */
const SmileLoader = ({ className = '', size = 'md' }) => (
  <div
    className={`smile-loader smile-loader--${size} ${className}`.trim()}
    aria-hidden="true"
  >
    <div className="smile-loader__ring" />
    <div className="smile-loader__face">
      <span className="smile-loader__eye smile-loader__eye--left" />
      <span className="smile-loader__eye smile-loader__eye--right" />
      <svg className="smile-loader__mouth" viewBox="0 0 40 18" fill="none">
        <path
          d="M8 4C12 12 28 12 32 4"
          stroke="#2f2a26"
          strokeWidth="2.6"
          strokeLinecap="round"
        />
      </svg>
    </div>
  </div>
);

export default SmileLoader;
